/**
 * Settings Page
 *
 * Purpose: Admin page for application settings
 */

export function SettingsPageView() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">Settings</h1>
        <p className="mt-2 text-gray-600">Manage application settings</p>
      </div>

      <div className="bg-white rounded-lg border border-gray-300 p-6">
        <p className="text-gray-600">
          Manage support contact, API keys, timezone, password, and profile from the sidebar.
        </p>
      </div>
    </div>
  )
}

